module.exports = __webpack_public_path__ + "img/img10.d9b18407.png";